// =========================================================
// Formatters (shared between the page, the modal and print)
// =========================================================

export const money = (value) =>
  Number(value || 0).toLocaleString("ar-EG", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString("ar-EG") : "-");

export const escapeHtml = (value) =>
  String(value ?? "").replace(
    /[&<>"']/g,
    (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char])
  );